import { render, staticRenderFns } from "./GroupConfig.vue?vue&type=template&id=c6c7e3be&scoped=true&"
import script from "./GroupConfig.vue?vue&type=script&lang=js&"
export * from "./GroupConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c7e3be",
  null
  
)

export default component.exports